import { useCallback } from 'react'
import { AxiosRequestConfig } from 'axios'

import { useAxiosInstance } from '@dhl/axios'

export const useMutator = <T>(base?: AxiosRequestConfig): ((config: AxiosRequestConfig) => Promise<T>) => {
  const axios = useAxiosInstance()

  return useCallback(
    (config: AxiosRequestConfig, options?: AxiosRequestConfig) =>
      // @ts-ignore TODO Figure out how to fix this
      axios({
        ...base,
        ...config,
        ...options,
      }).then(({ data }) => data),
    [axios, base]
  )
}
